import { Button, Menu, MenuItem, Typography, makeStyles, useTheme } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { memo, useEffect, useRef, useState } from 'react';

import useI18nCountries from '@/hooks/useI18nCountries.js';

import { dropdownFieldBase, fieldArrowColor } from '@/styles/inputStyles.ts';

const useStyles = makeStyles((theme) => ({
    formControl: {
        ...dropdownFieldBase(theme),
        [theme.breakpoints.down('xs')]: {
            marginBottom: 15,
        },
        '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
        },
    },
    downArrow: {
        color: fieldArrowColor(theme),
        marginRight: 15,
    },
    menuItem: {
        fontWeight: theme.weight.heading,
        fontSize: '1rem',
        color: theme.palette.common.darkGrey,
        textTransform: 'none',
    },
    requiredStar: {
        color: '#D32F2F',
        fontSize: '1.2em',
    },
    headingContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        maxHeight: 25,
    },
}));

const CountryDropDown = ({
    mainDataHeading,
    setData,
    data,
    noMarginTop = false,
    required = false,
    disabled = false,
}) => {
    const classes = useStyles();
    const theme = useTheme();
    const [privateCountryWidth, setPrivateCountryWidth] = useState('0');
    const [anchorEl, setAnchorEl] = useState(null);

    const countryList = useI18nCountries();

    const messageRefTwo = useRef();

    useEffect(() => {
        if (messageRefTwo.current) {
            messageRefTwo.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });
        }
    });
    useEffect(() => {
        if (data !== undefined && data !== null && data.length > 0) {
            setData(data);
        }
    }, []);

    const handleClickPrivateCountry = (event) => {
        const w = document.getElementById('privateCountry').clientWidth;
        setPrivateCountryWidth(w.toString());
        setAnchorEl(event.currentTarget);
    };

    const handleClosePrivatePersonalDataCountry = (pcode = '') => {
        setAnchorEl(null);
        if (pcode !== '') {
            setData(pcode);
        }
    };

    return (
        <div>
            <Button
                aria-controls="privateCountry"
                aria-haspopup="true"
                onClick={handleClickPrivateCountry}
                id="privateCountry"
                disableRipple
                disabled={disabled}
                className={classes.formControl}
                classes={{ label: classes.menuLabel }}
                style={{ marginTop: noMarginTop ? 0 : 10 }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                    }}
                >
                    <div className={classes.headingContainer}>
                        <Typography
                            style={{
                                fontFamily: theme.typography.fontFamily,
                                fontWeight: theme.weight.body,
                                fontSize: '0.875rem',
                                color: disabled ? theme.palette.text.disabled : theme.palette.common.darkGrey,
                                textTransform: 'none',
                                padding: 0,
                                marginLeft: 3,
                            }}
                        >
                            {/* {t("Country")} */}
                            {mainDataHeading}
                        </Typography>
                        {required && <span className={classes.requiredStar}>*</span>}
                    </div>
                    <Typography
                        style={{
                            fontFamily: theme.typography.fontFamily,
                            fontWeight: theme.weight.body,
                            fontSize: '1rem',
                            color: disabled ? theme.palette.text.disabled : theme.palette.common.darkGrey,
                            textTransform: 'none',
                            marginLeft: 3,
                            textAlign: 'left',
                        }}
                    >
                        {/* {epcountry} */}
                        {countryList[data]}
                    </Typography>
                </div>
                <KeyboardArrowDownIcon className={classes.downArrow} />
            </Button>

            <Menu
                id="privateCountry"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                keepMounted
                onClose={() => {
                    handleClosePrivatePersonalDataCountry();
                }}
                PaperProps={{
                    style: {
                        width: parseFloat(privateCountryWidth),
                        backgroundColor: 'white',
                        paddingTop: 10,

                        border: `2px solid ${theme.palette.common.yellow}`,
                        height: 400,
                    },
                }}
            >
                {Object.keys(countryList).map((key) => (
                    <MenuItem
                        data-testid={`dropdown-country-option-${key}`}
                        key={key}
                        className={classes.menuItem}
                        onClick={() => handleClosePrivatePersonalDataCountry(key)}
                        style={{
                            backgroundColor: key === data ? theme.palette.common.cream_disable : 'white',
                        }}
                        ref={key === data ? messageRefTwo : null}
                    >
                        {countryList[key]}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};
export default memo(CountryDropDown);
